import { IFormInput } from "./types";

export const defaultValues: IFormInput = {
  hours: null,
  media: null,
  liquidBudget: false,
  except: null,
};
